"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var SettingFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_SettingFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.764 15.904a.93.93 0 0 1-.722-.621l-.397-1.121a1.593 1.593 0 0 0-1.79-1.038l-1.164.215a.928.928 0 0 1-.898-.316 7.996 7.996 0 0 1-1.235-2.141.934.934 0 0 1 .176-.937l.77-.907a1.605 1.605 0 0 0 0-2.076l-.77-.907a.934.934 0 0 1-.176-.937c.3-.78.72-1.502 1.235-2.141a.928.928 0 0 1 .898-.316l1.164.215a1.593 1.593 0 0 0 1.79-1.038l.397-1.12a.93.93 0 0 1 .723-.622 8.014 8.014 0 0 1 2.46-.002.93.93 0 0 1 .724.622l.398 1.122a1.593 1.593 0 0 0 1.79 1.038l1.174-.217a.928.928 0 0 1 .898.316 7.997 7.997 0 0 1 1.232 2.133.934.934 0 0 1-.175.938l-.778.916a1.605 1.605 0 0 0 0 2.076l.778.916c.222.26.299.619.175.938a7.996 7.996 0 0 1-1.233 2.133.928.928 0 0 1-.897.316l-1.173-.217a1.593 1.593 0 0 0-1.791 1.038l-.398 1.122a.93.93 0 0 1-.723.622 8.017 8.017 0 0 1-2.462-.002ZM8.005 11a2.996 2.996 0 0 0 2.992-3c0-1.657-1.34-3-2.992-3a2.996 2.996 0 0 0-2.99 3c0 1.657 1.338 3 2.99 3Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_SettingFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = SettingFill;
exports["default"] = _default;